// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"dcc80494","892":"51d6f165","954":"6ee2ec7a"}[chunkId] + ".chunk.js";
};